<template>
  <v-card>
    <v-card-title>
      Typy služeb
    </v-card-title>
    <v-card-actions>
      <add-service-type-dialog @update="createServiceType">
        <template #default="{on, attrs}">
          <v-btn outlined
                 small
                 color="primary"
                 v-on="on"
                 class="mx-1"
                 v-bind="attrs">PŘIDAT TYP SLUŽBY</v-btn>
        </template>
      </add-service-type-dialog>
      <v-btn small color="secondary" :disabled="selectedServiceTypes.length === 0" outlined @click="removeServiceType">ODSTRANIT TYP SLUŽBY</v-btn>
    </v-card-actions>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1"
                  show-select
                  single-select
                  v-model="selectedServiceTypes"
                  @click:row="openServiceType"
                  item-key="_id"
    >
      <template v-slot:item.defaultPrice="{item}">
        {{ item.defaultPrice }} Kč
      </template>
      <template v-slot:item.unit="{item}">
        {{ getUnitLabel(item.unit) }}
      </template>
      <template v-slot:item.estimateConfigCount="{item}">
        {{ item.estimateConfiguration ? item.estimateConfiguration.length : 0 }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import {generateRequestParams} from '@/helper/global-helper'

export default {
  name: "ServiceTypesTable",
  data() {
    return {
      headers: [
        {text: 'Název', value: 'serviceName', sortable: false},
        {text: 'Výchozí cena', value: 'defaultPrice', sortable: false},
        {text: 'Jednotka', value: 'unit', sortable: false},
        {text: 'Počet konfigurací', value: 'estimateConfigCount', sortable: false},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      search: null,
      selectedServiceTypes: []
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.total
    },
    items() {
      if (!this.data) return []
      return this.data.data
    }
  },
  methods: {
    getData() {
      let params = generateRequestParams(
          this.options.itemsPerPage * (this.options.page - 1),
          this.options.itemsPerPage,
          null,
          this.options.sortDesc[this.options.sortBy.indexOf("createdAt")] ? "asc" : "desc"
      )
      this.axios.get('v1/service-types', {
        params
      })
          .then(({data}) => {
            this.data = data
          })
          .catch((error) => {
            this.$store.commit('addAlert', {
              type: 'error',
              message: 'Nepodařilo se načíst typy služeb'
            })
          })
    },
    createServiceType(data) {
      this.getData()
    },
    openServiceType({ _id }) {
      this.$router.push('/app/service-types/' + _id)
    },
    removeServiceType() {
      const serviceTypeId = this.selectedServiceTypes[0]._id
      this.axios.delete(`/v1/service-types/${serviceTypeId}`).then(() => {
        this.data.data = this.data.data.filter(item => item._id !== serviceTypeId)
        this.selectedServiceTypes = []
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně odstraněn"
        })
      })
          .catch((error) => {
            this.$store.commit('addAlert', {
              type: 'error',
              message: 'Nepodařilo se odstranit typ služby'
            })
          })
    },
    getUnitLabel(unit) {
      const units = {
        'hour': 'Hodina',
        'area': 'Plocha',
        'customer': 'Zákazník'
      }
      return units[unit] || unit
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
</style>
